const TOOLTIP_PORTAL_ID = "tooltip-portal-root";

export function getTooltipPortalRoot(): HTMLElement {
  const existing = document.getElementById(TOOLTIP_PORTAL_ID);
  if (existing) return existing;

  const root = document.createElement("div");
  root.id = TOOLTIP_PORTAL_ID;
  root.setAttribute("data-tooltip-portal", "");
  document.body.appendChild(root);
  return root;
}
